import { useEffect, useState } from "react";
import { fetchVourcherList, saveVourcher } from "../../api/Vourcher";
import { Vourcher } from "../../api/VourcherType";
import { getUserPoints } from "../../api/points";
import { toast } from "react-toastify";
import GuidelineModal from "./GuidelineModal";

interface AccumulatedPointsProps {
    onVoucherCollected?: () => void;
}

export default function AccumulatedPoints({ onVoucherCollected }: AccumulatedPointsProps) {
    const [open, setOpen] = useState(false);
    const [activeVoucherId, setActiveVoucherId] = useState<number | null>(null);
    const [vouchers, setVouchers] = useState<Vourcher[]>([]);
    const [pointBalance, setPointBalance] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [collectingVoucherId, setCollectingVoucherId] = useState<number | null>(null);

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            const [vouchersRes, pointsRes] = await Promise.all([
                fetchVourcherList({ page: 1, limit: 12 }),
                getUserPoints(),
            ]);

            if (vouchersRes?.status && vouchersRes.data?.items) {
                setVouchers(vouchersRes.data.items);
            } else {
                setVouchers([]);
            }

            if (pointsRes?.status && pointsRes.data) {
                setPointBalance(Number(pointsRes.data.point_balance || 0));
            }

            setIsLoading(false);
        };

        loadData();
    }, []);

    const getVoucherTitle = (voucher: Vourcher) => {
        if (voucher.type === 2) {
            return `GIẢM ${Number(voucher.value || 0)}%`;
        }
        if (voucher.type === 3) {
            return "ƯU ĐÃI PHÍ VẬN CHUYỂN";
        }
        return `GIẢM ${Number(voucher.value || 0).toLocaleString("vi-VN")}đ`;
    };

    const handleCollectVoucher = async (voucherId: number) => {
        if (collectingVoucherId !== null) return;

        setCollectingVoucherId(voucherId);
        try {
            const res = await saveVourcher(voucherId);
            if (res.status) {
                toast.success(res.data?.message || res.msg || "Đổi điểm thành công.", {
                    position: "bottom-right",
                });
                onVoucherCollected?.();
                return;
            }

            toast.error(res.error?.message || res.msg || "Đổi điểm thất bại.", {
                position: "bottom-right",
            });
        } catch (error) {
            console.error("Collect voucher failed", error);
            toast.error("Đổi điểm thất bại. Vui lòng thử lại.", {
                position: "bottom-right",
            });
        } finally {
            setCollectingVoucherId(null);
        }
    };

    return (
        <div className="MuiContainer-root styles_container__3w0uC MuiContainer-maxWidthLg">
            <div id="sectionMyVoucher" style={{ scrollMarginTop: "115px" }}>
                <div className="MuiBox-root css-yd8sa2">
                    <div className="MuiBox-root css-vqah6a">
                        <div className="styles_voucherListTitle_container__u_yeF MuiBox-root css-0">
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "inline-block",
                                    overflow: "hidden",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                    position: "relative",
                                    maxWidth: "100%",
                                }}
                            >
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "block",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        maxWidth: "100%",
                                    }}
                                >
                                    <img
                                        alt=""
                                        aria-hidden="true"
                                        src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='32'%20height='32'/%3e"
                                        style={{
                                            display: "block",
                                            maxWidth: "100%",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                        }}
                                    />
                                </span>
                                <img
                                    data-origin-url="https://cdn-web-next.thuocsi.vn/images/promoCode/loyalty_logo.svg"
                                    src="https://cdn-web-next.thuocsi.vn/images/promoCode/loyalty_logo.svg"
                                    decoding="async"
                                    data-nimg="intrinsic"
                                    style={{
                                        fontSize: "32px",
                                        position: "absolute",
                                        inset: 0,
                                        boxSizing: "border-box",
                                        padding: 0,
                                        border: "none",
                                        margin: "auto",
                                        display: "block",
                                        width: 0,
                                        height: 0,
                                        minWidth: "100%",
                                        maxWidth: "100%",
                                        minHeight: "100%",
                                        maxHeight: "100%",
                                    }}
                                />
                            </span>

                            <p className="MuiTypography-root MuiTypography-body2">
                                Mã Giảm Giá
                            </p>
                        </div>

                        {/* <div className="MuiBox-root css-70qvj9">
                            <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: 0, margin: 0, padding: 0, position: "relative", maxWidth: "100%" }}>
                                <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: 0, margin: 0, padding: 0, maxWidth: "100%" }}>
                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: 0, margin: 0, padding: 0 }} />
                                </span>
                                <img alt="ts coin" data-origin-url="https://cdn-web-next.thuocsi.vn/images/promoCode/ts_coin.svg" src="https://cdn-web-next.thuocsi.vn/images/promoCode/ts_coin.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: 0, boxSizing: "border-box", padding: 0, border: "none", margin: "auto", display: "block", width: 0, height: 0, minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                            </span>
                            <span className="styles_coin__Dlbqz">Điểm hiện có:&nbsp; {pointBalance.toLocaleString("vi-VN")} </span>
                        </div> */}
                    </div>

                    {/* ===== GRID LIST ===== */}
                    <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2">
                        {isLoading && (
                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-12">
                                <p className="MuiTypography-root MuiTypography-body2">Đang tải voucher...</p>
                            </div>
                        )}

                        {!isLoading && vouchers.length === 0 && (
                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-12">
                                <p className="MuiTypography-root MuiTypography-body2">Hiện chưa có voucher đổi điểm.</p>
                            </div>
                        )}

                        {!isLoading && vouchers.map((voucher) => {
                            const isCollecting = collectingVoucherId === voucher.id;
                            return (
                                <div
                                    key={voucher.id}
                                    className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-4"
                                    style={{ position: "relative" }}
                                >
                                    <div
                                        className="MuiGrid-root"
                                        style={{ position: "relative", overflow: "hidden" }}
                                    >
                                        <div className="styles_voucherLeftMissingPart__hRuGU" />

                                        <div className="MuiGrid-root styles_voucherItem_wrapper__Ilu2K">
                                            <div className="MuiGrid-root styles_voucherContainer_upper__qxePy MuiGrid-container">
                                                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9 MuiGrid-grid-md-9">
                                                    <p className="MuiTypography-root styles_voucherContent_title__OgTJv MuiTypography-body2 MuiTypography-noWrap">
                                                        {getVoucherTitle(voucher)}
                                                    </p>

                                                    <div
                                                        className="MuiTypography-root MuiTypography-body2 styles_voucherContent_desc__4JG9A styles_content_2Line__fXy9o"
                                                        style={{ padding: "12px 0px 0px" }}
                                                    >
                                                        {voucher.describe || "Khuyến mãi theo hình thức đổi điểm tích luỹ"}
                                                    </div>
                                                </div>

                                                <div className="MuiGrid-root styles_loyaltyLogoWrapper__dE3_d MuiGrid-item MuiGrid-grid-xs-3 MuiGrid-grid-md-3">
                                                    <span
                                                        style={{
                                                            boxSizing: "border-box",
                                                            display: "inline-block",
                                                            overflow: "hidden",
                                                            width: "initial",
                                                            height: "initial",
                                                            background: "none",
                                                            opacity: 1,
                                                            border: "0px",
                                                            margin: "0px",
                                                            padding: "0px",
                                                            position: "relative",
                                                            maxWidth: "100%",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                boxSizing: "border-box",
                                                                display: "block",
                                                                width: "initial",
                                                                height: "initial",
                                                                background: "none",
                                                                opacity: 1,
                                                                border: "0px",
                                                                margin: "0px",
                                                                padding: "0px",
                                                                maxWidth: "100%",
                                                            }}
                                                        >
                                                            <img
                                                                alt=""
                                                                aria-hidden="true"
                                                                src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2768%27%20height=%2768%27/%3e"
                                                                style={{
                                                                    display: "block",
                                                                    maxWidth: "100%",
                                                                    width: "initial",
                                                                    height: "initial",
                                                                    background: "none",
                                                                    opacity: 1,
                                                                    border: "0px",
                                                                    margin: "0px",
                                                                    padding: "0px",
                                                                }}
                                                            />
                                                        </span>

                                                        <img
                                                            alt="logo voucher"
                                                            src={voucher.avatar || ""}
                                                            decoding="async"
                                                            data-nimg="intrinsic"
                                                            style={{
                                                                position: "absolute",
                                                                inset: "0px",
                                                                boxSizing: "border-box",
                                                                padding: "0px",
                                                                border: "none",
                                                                margin: "auto",
                                                                display: "block",
                                                                width: "0px",
                                                                height: "0px",
                                                                minWidth: "100%",
                                                                maxWidth: "100%",
                                                                minHeight: "100%",
                                                                maxHeight: "100%",
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="styles_voucherDivider__oxdPQ" />

                                            <div className="MuiBox-root css-0">
                                                <div className="MuiBox-root css-1wrcl4x">
                                                    <span className="styles_loyaltyPromo_promoPoint__Hgb49">
                                                        Mã: {voucher.code}
                                                    </span>

                                                    <div className="MuiBox-root css-1elebcq">
                                                        <button
                                                            className="MuiButtonBase-root MuiButton-root MuiButton-text"
                                                            tabIndex={0}
                                                            type="button"
                                                            style={{
                                                                color: "rgb(14, 25, 131)",
                                                                padding: "6px 8px",
                                                                textTransform: "unset",
                                                            }}
                                                            onClick={() => {
                                                                setActiveVoucherId(voucher.id);
                                                                setOpen(true);
                                                            }}
                                                        >
                                                            <span className="MuiButton-label">
                                                                <svg
                                                                    className="MuiSvgIcon-root"
                                                                    focusable="false"
                                                                    viewBox="0 0 24 24"
                                                                    aria-hidden="true"
                                                                    style={{ width: 16, height: 16 }}
                                                                >
                                                                    <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                                                                </svg>

                                                                <span
                                                                    className="MuiTypography-root MuiTypography-body2"
                                                                    style={{
                                                                        paddingLeft: 4,
                                                                        fontSize: 12,
                                                                        lineHeight: "18px",
                                                                    }}
                                                                >
                                                                    Xem chi tiết
                                                                </span>
                                                            </span>
                                                            <span className="MuiTouchRipple-root" />
                                                        </button>

                                                        <button
                                                            className="MuiButtonBase-root MuiButton-root MuiButton-text"
                                                            tabIndex={0}
                                                            type="button"
                                                            disabled={isCollecting}
                                                            onClick={() => handleCollectVoucher(voucher.id)}
                                                        >
                                                            <span className="MuiButton-label">
                                                                <span>{isCollecting ? "Đang đổi..." : "Lấy mã"}</span>
                                                            </span>
                                                            <span className="MuiTouchRipple-root" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="styles_voucherRightMissingPart__139Rt" />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <GuidelineModal
                open={open}
                voucherId={activeVoucherId}
                onClose={() => {
                    setOpen(false);
                    setActiveVoucherId(null);
                }}
            />
        </div>
    );
}
